module.exports = "<h2 style=\"min-height: 30rem; text-align: center;\">\n  Oops! Page not found.\n</h2>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/page-not-found/page-not-found.component.html
// module id = 561
// module chunks = 0